module.exports = __webpack_public_path__ + "static/media/android.706d1049.png";